// Routes.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import StaffPage from "./features/services/staff/pages/StaffPage";
import Layout from "./layout/Layout";
import Dashboard from "./features/dashboard/pages/Dashboard";
import UserPage from "./features/services/user/pages/UserPage";

const ApplicationRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="users" element={<UserPage />} />
        <Route path="staffs" element={<StaffPage />} />
        <Route path="treatments" element={<UserPage />} />
        <Route path="patient-registration" element={<UserPage />} />
      </Route>
    </Routes>
  );
};

export default ApplicationRoutes;
